export const GIF_CACHE_NAME = "gif-cache";
